<template>
  <div class="relative w-6 h-6 inline-flex justify-center items-center flex-shrink">
    <i
      ref="iconRef"
      class="pi pi-question-circle gray-800 cursor-pointer"
      @click.stop="toggleTooltip"
    />
    <Teleport to="body">
      <div
        v-if="showTooltip"
        ref="tooltipRef"
        class="fixed z-50 bg-gray-800/90 rounded-xl shadow-lg min-w-[200px] max-w-[300px]"
        :style="tooltipStyle"
      >
        <div class="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[8px] border-r-[8px] border-b-[8px] border-l-transparent border-r-transparent border-b-gray-800/95"></div>
        <div class="p-4 text-sm text-white " style="font-family: 'Rubik', sans-serif;">
          <slot></slot>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';

const showTooltip = ref(false);
const tooltipRef = ref(null);
const iconRef = ref(null);
const tooltipStyle = ref({});

const toggleTooltip = (event) => {
  event.stopPropagation();
  showTooltip.value = !showTooltip.value;

  if (showTooltip.value) {
    nextTick(() => {
      calculateTooltipPosition();
    });
  }
};

const calculateTooltipPosition = () => {
  if (!tooltipRef.value || !iconRef.value) return;

  // Get the icon's position relative to the viewport
  const iconRect = iconRef.value.getBoundingClientRect();
  const tooltipRect = tooltipRef.value.getBoundingClientRect();

  // Account for scroll position to position tooltip correctly
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Calculate the center position of the icon
  const iconCenterX = iconRect.left + (iconRect.width / 2);

  // Position the tooltip right below the icon
  tooltipStyle.value = {
    top: `${iconRect.bottom + scrollTop + 10}px`,
    left: `${iconCenterX + scrollLeft - (tooltipRect.width / 2)}px`,
  };
};

const handleClickOutside = (event) => {
  if (tooltipRef.value && !tooltipRef.value.contains(event.target) &&
    iconRef.value && !iconRef.value.contains(event.target) &&
    showTooltip.value) {
    showTooltip.value = false;
  }
};

const handleScroll = () => {
  if (showTooltip.value) {
    // Close the tooltip when scrolling
    showTooltip.value = false;
  }
};

const handleResize = () => {
  if (showTooltip.value) {
    calculateTooltipPosition();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('scroll', handleScroll, true);
});
</script>
